<!--
  --
  -- メールアドレス設定 グループ
  --
  -->
<template>
  <div>
    <!-- メールアドレス -->
    <c-identification-email-form
      :form="form" @send="onSend"
    >
      <template #title>
        <slot name="title"/>
      </template>

      <template>
        <slot name="email-note"/>
      </template>

      <template #submit-text>確認コードを送信</template>
    </c-identification-email-form>

    <!-- 確認コード -->
    <c-identification-code-form
      v-if="form.code"
      class="mt-4"
      :form="form"
      @verified="onVerified"
    >
      <template>
        <slot name="verify-note"/>
      </template>

      <template #submit-text>コードを確認</template>
    </c-identification-code-form>
  </div>
</template>

<script>
import CIdentificationEmailForm from '@/components/CIdentificationEmailForm'
import CIdentificationCodeForm from '@/components/CIdentificationCodeForm'

import * as http from '@/libs/http'
import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'CEmailGroup',
  components: {
    CIdentificationEmailForm,
    CIdentificationCodeForm
  },
  props: {
    email: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    // フォームデータ
    form: {
      email: '',
      code: '',
      expire: 0
    }
  }),

  /**
   * コンポーネント作成時
   */
  created () {
    // プロパティ email の内容を form に反映する
    this.form.email = this.email
  },
  methods: {
    /**
     * メールを送信する
     *
     * @param {String} email 送信先メールアドレス
     * @param {Function} completed 処理完了時に呼び出すコールバック関数
     */
    onSend (email, completed) {
      run(async () => {
        let errors = false

        // メールを送信する
        const orgcode = this.getters['org/code']
        const resp = await api.verifyEmail(orgcode, email)

        // Response を処理する
        if (resp.status === http.Conflict) {
          errors = REASON_CONFLICT
        } else if (resp.status === http.Forbidden) {
          errors = REASON_FORBIDDEN
        } else {
          this.form.code = resp.data.sendcode
          this.form.expire = resp.data.expire
        }

        // 処理完了を通知する
        completed(errors)
      })
    },

    /**
     * コードが確認された
     *
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onVerified (failed) {
      // メールアドレスが認証されたことを通知する
      this.$emit('verified', this.form.email, failed)
    }
  }
}
//

const REASON_CONFLICT = [
  '指定のメールアドレスは既に登録されています。'
]

const REASON_FORBIDDEN = [
  '指定のメールアドレスは登録を拒否されました。',
  '運営会社にご確認ください。'
]

</script>
